import context, { getDefaultState } from 'chimera/all/store/context'
import deepmerge from 'deepmerge'

export const state = () => {
  return deepmerge(getDefaultState(), {
    country: 'be',
    language: 'fr',
  })
}

export default {
  ...context,
  state,
}
